import React, { useState, useEffect } from 'react';
import {
  FiHome, FiFolder, FiDollarSign, FiAward, FiEdit, FiUsers,
  FiCalendar, FiClock, FiBell, FiSearch, FiCreditCard, FiBook, FiBookOpen,
  FiHelpCircle, FiZap, FiShield, FiChevronLeft, FiChevronRight,
  FiSun, FiMoon,
} from 'react-icons/fi';
import { useTheme } from '../utils/theme';
import './Sidebar.css';

const Sidebar = ({ currentView, onNavigate, user, collapsed: collapsedProp, onCollapsedChange }) => {
  // Support controlled (parent-owned) + uncontrolled (legacy) modes so App can
  // react to collapse state and adjust the main-content margin accordingly.
  const [internalCollapsed, setInternalCollapsed] = useState(() => {
    try { return localStorage.getItem('sb_collapsed') === '1'; } catch { return false; }
  });
  const collapsed = collapsedProp != null ? collapsedProp : internalCollapsed;
  const setCollapsed = (v) => {
    if (onCollapsedChange) onCollapsedChange(v);
    else setInternalCollapsed(v);
    try { localStorage.setItem('sb_collapsed', v ? '1' : '0'); } catch {}
  };
  useEffect(() => {
    if (collapsedProp == null) {
      try { localStorage.setItem('sb_collapsed', internalCollapsed ? '1' : '0'); } catch {}
    }
  }, [internalCollapsed, collapsedProp]);
  const { theme, setTheme } = useTheme();

  const item = (view, icon, label) => (
    <button
      className={`sb-item ${currentView === view ? 'sb-item--active' : ''}`}
      onClick={() => onNavigate(view)}
      title={collapsed ? label : undefined}
    >
      {icon}
      {!collapsed && <span>{label}</span>}
    </button>
  );

  return (
    <nav className={`sb ${collapsed ? 'sb--collapsed' : ''}`}>
      <div className="sb-top">
        <div className="sb-logo" onClick={() => onNavigate('dashboard')}>
          <span className="sb-logo-icon">🔬</span>
          {!collapsed && <span className="sb-logo-text">Mnevia</span>}
        </div>
      </div>

      <div className="sb-section">
        {!collapsed && <span className="sb-label">Research</span>}
        {item('dashboard', <FiHome />, 'Home')}
        {item('collections', <FiFolder />, 'Collections')}
        {item('search', <FiSearch />, 'Search')}
        {item('paper-agent', <FiEdit />, 'Draft Paper')}
        {item('monitors', <FiBell />, 'Monitors')}
      </div>

      <div className="sb-section">
        {!collapsed && <span className="sb-label">Funding</span>}
        {item('funding', <FiDollarSign />, 'Opportunities')}
        {item('grant-agent', <FiAward />, 'Draft Proposal')}
        {item('instant-review', <FiZap />, 'Instant Review')}
        {item('sample-library', <FiBookOpen />, 'Sample Proposals')}
      </div>

      <div className="sb-section">
        {!collapsed && <span className="sb-label">Lab</span>}
        {item('teams', <FiUsers />, 'Teams')}
        {item('lifecycle', <FiCalendar />, 'Tracker')}
        {item('calendar', <FiClock />, 'Calendar')}
      </div>

      <div className="sb-spacer" />

      <div className="sb-section sb-section--bottom">
        {item('membership', <FiCreditCard />, 'Membership')}
        {item('docs', <FiBook />, 'Docs')}
        {user?.is_admin && item('admin', <FiShield />, 'Admin')}
      </div>

      <button
        className="sb-theme-btn"
        onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
        title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {theme === 'dark' ? <FiSun /> : <FiMoon />}
        {!collapsed && <span>{theme === 'dark' ? 'Light mode' : 'Dark mode'}</span>}
      </button>

      <button className="sb-collapse-btn" onClick={() => setCollapsed(!collapsed)}>
        {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
        {!collapsed && <span>Collapse</span>}
      </button>
    </nav>
  );
};

export default Sidebar;
